import React from 'react'
import { ContentHeader } from '../layout/Content'

function ReportsHeader() { return ( <ContentHeader title='Reports'/> ) }

export default React.memo(ReportsHeader)
